import { render, staticRenderFns } from "./mantenimiento.vue?vue&type=template&id=463fa302&scoped=true&"
import script from "./mantenimiento.vue?vue&type=script&lang=js&"
export * from "./mantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463fa302",
  null
  
)

export default component.exports